import { render } from "./RenewSubscriptionDialog.vue?vue&type=template&id=312c5388"
import script from "./RenewSubscriptionDialog.vue?vue&type=script&lang=js"
export * from "./RenewSubscriptionDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__